/*
 * Generador de códigos de barras y QR — projit.es
 *
 * Motor de dibujo: bwip-js (MIT), cargado antes que este fichero como
 * `assets/bwip-js-min.js`. No hay dependencias de red ni backend: todo se
 * genera en el navegador del visitante.
 */
(function () {
  'use strict';

  if (typeof bwipjs === 'undefined') {
    var aviso = document.getElementById('gc-error');
    if (aviso) {
      aviso.hidden = false;
      aviso.textContent = 'No se ha podido cargar el motor de generación. Recarga la página.';
    }
    return;
  }

  // -----------------------------------------------------------------
  // Catálogo de símbolos. La clave es el `bcid` que espera bwip-js.
  //   linear  -> el símbolo es una barra 1D: se ofrece control de alto.
  //   text    -> valor por defecto de "mostrar texto legible".
  //   family  -> activa el selector de corrección de errores ('qr',
  //              'aztec' o 'pdf417'; cada familia tiene su propia escala).
  //   gs1     -> activa el asistente de identificadores de aplicación GS1.
  // -----------------------------------------------------------------
  var TYPES = {
    code128: { label: 'Code 128', linear: true, text: true, example: 'PROJIT-0001234',
      hint: 'El más versátil: letras, números y símbolos en poco espacio. Estándar en logística interna y expedición.' },
    code11: { label: 'Code 11', linear: true, text: true, example: '01234567' },
    code39: { label: 'Code 39', linear: true, text: true, example: 'PROJIT-123',
      hint: 'Solo mayúsculas, números y algunos símbolos, pero lo lee cualquier lector antiguo sin configurar nada.' },
    code39ext: { label: 'Code 39 Extendido', linear: true, text: true, example: 'Projit-123' },
    code93: { label: 'Code 93', linear: true, text: true, example: 'PROJIT123' },
    code93ext: { label: 'Code 93 Extendido', linear: true, text: true, example: 'Projit-123' },
    interleaved2of5: { label: 'Entrelazado 2 de 5 (ITF)', linear: true, text: true, example: '1234567890',
      hint: 'Solo números, siempre en pares. Muy usado en cajas de transporte por su alta densidad.' },
    itf14: { label: 'ITF-14', linear: true, text: true, example: '10012345678902',
      hint: 'La versión de 14 dígitos del entrelazado 2 de 5, estándar para marcar cajas y palés (GS1-14).' },
    industrial2of5: { label: 'Industrial 2 de 5', linear: true, text: true, example: '1234567890' },
    matrix2of5: { label: 'Matrix 2 de 5', linear: true, text: true, example: '1234567890' },
    coop2of5: { label: 'COOP 2 de 5', linear: true, text: true, example: '1234567890' },
    datalogic2of5: { label: 'Datalogic 2 de 5', linear: true, text: true, example: '1234567890' },
    iata2of5: { label: 'IATA 2 de 5', linear: true, text: true, example: '1234567890' },
    code2of5: { label: 'Código 25 (Estándar 2 de 5)', linear: true, text: true, example: '1234567890' },
    rationalizedCodabar: { label: 'Codabar', linear: true, text: true, example: 'A12345678A',
      hint: 'Habitual en bancos de sangre, bibliotecas y mensajería por su simplicidad y bajo coste de lector.' },
    msi: { label: 'MSI Plessey', linear: true, text: true, example: '1234567890' },
    plessey: { label: 'Plessey (UK)', linear: true, text: true, example: '1234567890' },
    telepen: { label: 'Telepen', linear: true, text: true, example: 'PROJIT' },
    telepennumeric: { label: 'Telepen Numérico', linear: true, text: true, example: '1234567890' },
    channelcode: { label: 'Channel Code', linear: true, text: true, example: '123456' },
    posicode: { label: 'PosiCode', linear: true, text: true, example: '1234567890' },
    bc412: { label: 'BC412', linear: true, text: true, example: '1234567890' },

    ean13: { label: 'EAN-13', linear: true, text: true, example: '5901234123457',
      hint: 'El código de las estanterías de cualquier tienda. 13 dígitos, el último de control automático.' },
    ean8: { label: 'EAN-8', linear: true, text: true, example: '96385074',
      hint: 'Versión corta de EAN para envases pequeños donde no cabe un EAN-13.' },
    ean2: { label: 'EAN-2 (complemento)', linear: true, text: true, example: '12' },
    ean5: { label: 'EAN-5 (complemento)', linear: true, text: true, example: '12345' },
    ean14: { label: 'EAN-14', linear: true, text: true, example: '10012345678902' },
    upca: { label: 'UPC-A', linear: true, text: true, example: '036000291452',
      hint: 'El equivalente a EAN-13 en Norteamérica: 12 dígitos.' },
    upce: { label: 'UPC-E', linear: true, text: true, example: '01234565' },
    isbn: { label: 'ISBN (libros)', linear: true, text: true, example: '978-1-56581-231-4' },
    ismn: { label: 'ISMN (partituras)', linear: true, text: true, example: '979-0-2600-0043-8' },
    issn: { label: 'ISSN (publicaciones periódicas)', linear: true, text: true, example: '1234-5679' },
    sscc18: { label: 'SSCC-18 (unidad logística)', linear: true, text: true, example: '106141411234567897' },

    'gs1-128': { label: 'GS1-128 (UCC/EAN-128)', linear: true, text: true, gs1: true, example: '(01)00012345600012(17)261231',
      hint: 'El estándar de logística: en la misma barra codifica GTIN, lote, caducidad o número de serie con identificadores de aplicación (AI).' },
    databaromni: { label: 'GS1 DataBar Omnidireccional', linear: true, text: true, example: '(01)00012345600012' },
    databartruncated: { label: 'GS1 DataBar Truncado', linear: true, text: true, example: '(01)00012345600012' },
    databarstacked: { label: 'GS1 DataBar Apilado', linear: true, text: true, example: '(01)00012345600012' },
    databarstackedomni: { label: 'GS1 DataBar Apilado Omnidireccional', linear: true, text: true, example: '(01)00012345600012' },
    databarlimited: { label: 'GS1 DataBar Limitado', linear: true, text: true, example: '(01)00012345600012' },
    databarexpanded: { label: 'GS1 DataBar Expandido', linear: true, text: true, gs1: true, example: '(01)00012345600012(3202)000150' },
    databarexpandedstacked: { label: 'GS1 DataBar Expandido Apilado', linear: true, text: true, gs1: true, example: '(01)00012345600012(3202)000150' },
    gs1datamatrix: { label: 'GS1 Data Matrix', linear: false, text: false, gs1: true, family: null, example: '(01)00012345600012(17)261231(10)LOTE7',
      hint: 'El marcaje típico de sanidad y electrónica: mismo contenido que GS1-128 pero en un cuadrado diminuto, apto para grabado directo sobre pieza.' },
    gs1datamatrixrectangular: { label: 'GS1 Data Matrix Rectangular', linear: false, text: false, gs1: true, example: '(01)00012345600012(17)261231' },
    gs1qrcode: { label: 'GS1 QR Code', linear: false, text: false, gs1: true, family: 'qr', example: '(01)00012345600012(17)261231' },
    gs1dotcode: { label: 'GS1 DotCode', linear: false, text: false, gs1: true, example: '(01)00012345600012(10)LOTE7' },
    gs1dldatamatrix: { label: 'GS1 Digital Link (Data Matrix)', linear: false, text: false, example: 'https://projit.es/01/00012345600012?10=LOTE7' },
    gs1dlqrcode: { label: 'GS1 Digital Link (QR Code)', linear: false, text: false, family: 'qr', example: 'https://projit.es/01/00012345600012?10=LOTE7' },
    gs1northamericancoupon: { label: 'GS1 Cupón Norteamericano', linear: false, text: false, example: '(01)00012345600012(8110)106141411234567897' },

    qrcode: { label: 'QR Code', linear: false, text: false, family: 'qr', example: 'https://www.projit.es',
      hint: 'Cualquier móvil lo lee sin lector dedicado. Guarda mucho más dato que un código 1D: URLs, texto largo, vCards, redes Wi-Fi.' },
    microqrcode: { label: 'Micro QR Code', linear: false, text: false, family: 'qr', example: 'PROJIT-123' },
    rectangularmicroqrcode: { label: 'rMQR (Micro QR Rectangular)', linear: false, text: false, family: 'qr', example: 'PROJIT-123' },
    datamatrix: { label: 'Data Matrix', linear: false, text: false, example: 'PROJIT-0001234',
      hint: 'El más compacto de los 2D. Estándar en electrónica y sanidad para marcar piezas diminutas por láser o tinta.' },
    datamatrixrectangular: { label: 'Data Matrix Rectangular', linear: false, text: false, example: 'PROJIT-0001234' },
    pdf417: { label: 'PDF417', linear: false, text: false, family: 'pdf417', example: 'Projit S.L. - Equipamiento de identificación automática',
      hint: 'El de los DNI y carnés de conducir: guarda cientos de caracteres en un rectángulo alargado.' },
    pdf417compact: { label: 'PDF417 Compacto', linear: false, text: false, family: 'pdf417', example: 'PROJIT-0001234' },
    micropdf417: { label: 'MicroPDF417', linear: false, text: false, family: 'pdf417', example: 'PROJIT-0001234' },
    azteccode: { label: 'Aztec Code', linear: false, text: false, family: 'aztec', example: 'PROJIT-0001234',
      hint: 'No necesita margen de silencio alrededor. Lo usan los billetes de tren y avión por eso mismo.' },
    azteccodecompact: { label: 'Aztec Code Compacto', linear: false, text: false, family: 'aztec', example: 'PROJIT-123' },
    maxicode: { label: 'MaxiCode', linear: false, text: false, example: 'PROJIT-0001234',
      hint: 'Tamaño fijo, pensado para clasificación automática de paquetería a alta velocidad (lo usa UPS).' },
    codablockf: { label: 'Codablock F', linear: false, text: false, example: 'PROJIT-0001234' },
    hanxin: { label: 'Han Xin Code', linear: false, text: false, example: 'PROJIT-0001234' },
    dotcode: { label: 'DotCode', linear: false, text: false, example: 'PROJIT-0001234',
      hint: 'Formado por puntos, no por cuadrados: se imprime bien incluso a la velocidad de una impresora de inyección industrial.' },
    code16k: { label: 'Code 16K', linear: false, text: false, example: 'PROJIT-0001234' },
    code49: { label: 'Code 49', linear: false, text: false, example: 'PROJIT-0001234' },
    codeone: { label: 'Code One', linear: false, text: false, example: 'PROJIT-0001234' },
    ultracode: { label: 'Ultracode', linear: false, text: false, example: 'PROJIT-0001234' },

    hibccode128: { label: 'HIBC Code 128', linear: true, text: true, example: 'A123BJ034544401017' },
    hibccode39: { label: 'HIBC Code 39', linear: true, text: true, example: 'A123BJ034544401017',
      hint: 'El estándar sanitario (Health Industry Bar Code) sobre Code 39: siempre empieza por "+".' },
    hibcdatamatrix: { label: 'HIBC Data Matrix', linear: false, text: false, example: 'A123BJ034544401017' },
    hibcdatamatrixrectangular: { label: 'HIBC Data Matrix Rectangular', linear: false, text: false, example: 'A123BJ034544401017' },
    hibcqrcode: { label: 'HIBC QR Code', linear: false, text: false, family: 'qr', example: 'A123BJ034544401017' },
    hibcpdf417: { label: 'HIBC PDF417', linear: false, text: false, family: 'pdf417', example: 'A123BJ034544401017' },
    hibcmicropdf417: { label: 'HIBC MicroPDF417', linear: false, text: false, family: 'pdf417', example: 'A123BJ034544401017' },
    hibcazteccode: { label: 'HIBC Aztec Code', linear: false, text: false, family: 'aztec', example: 'A123BJ034544401017' },
    hibccodablockf: { label: 'HIBC Codablock F', linear: false, text: false, example: 'A123BJ034544401017' },
    pzn: { label: 'PZN (Pharmazentralnummer)', linear: true, text: true, example: '1234567',
      hint: 'Identifica el medicamento en el mercado alemán y austriaco. Solo números.' },
    pharmacode: { label: 'Pharmacode', linear: true, text: true, example: '123456',
      hint: 'No lleva dígito de control ni distingue mayúsculas: solo confirma "es este envase y no otro" en la línea de envasado.' },
    pharmacode2: { label: 'Pharmacode de Dos Pistas', linear: true, text: true, example: '123456' },
    code32: { label: 'Pharmacode Italiano (Code 32)', linear: true, text: true, example: '1234567890' },

    postnet: { label: 'USPS POSTNET', linear: false, text: false, example: '55555-1237' },
    planet: { label: 'USPS PLANET', linear: false, text: false, example: '401234567891' },
    onecode: { label: 'USPS Intelligent Mail', linear: false, text: false, example: '01234567094987654321012345678' },
    royalmail: { label: 'Royal Mail 4 State', linear: false, text: false, example: 'SN34RD1A' },
    kix: { label: 'KIX (Correos Países Bajos)', linear: false, text: false, example: '1231FZ13' },
    mailmark: { label: 'Royal Mail Mailmark', linear: false, text: false, example: '01000000000000000AA00AA0A' },
    japanpost: { label: 'Correos de Japón', linear: false, text: false, example: '6300012-3-4-5' },
    auspost: { label: 'Correos de Australia', linear: false, text: false, example: '5956439111ABA' },
    identcode: { label: 'Deutsche Post Identcode', linear: true, text: true, example: '563102430313' },
    leitcode: { label: 'Deutsche Post Leitcode', linear: true, text: true, example: '2110098701605' },

    swissqrcode: { label: 'Swiss QR Code', linear: false, text: false, family: 'qr', example: 'SPC\n0200\n1\nCH4431999123000889012\n...' },
    flattermarken: { label: 'Flattermarken', linear: true, text: false, example: '1234567890' },
    mands: { label: 'Marks & Spencer', linear: true, text: true, example: '1234567890123' },
    aztecrune: { label: 'Aztec Runes', linear: false, text: false, example: '128' }
  };

  // Orden curado por categoría — no todo el catálogo, pero sí "todos los
  // tipos" con relevancia real, agrupados como en los generadores de
  // referencia (TEC-IT, GS1) para que se puedan hojear sin perderse.
  var CATEGORIES = [
    { id: 'populares', label: 'Más usados', types:
      ['code128', 'code39', 'ean13', 'upca', 'itf14', 'qrcode', 'datamatrix', 'pdf417', 'gs1-128', 'rationalizedCodabar'] },
    { id: '1d', label: 'Código de barras 1D', types:
      ['code128', 'code11', 'code39', 'code39ext', 'code93', 'code93ext', 'interleaved2of5', 'itf14',
       'industrial2of5', 'matrix2of5', 'coop2of5', 'datalogic2of5', 'iata2of5', 'code2of5',
       'rationalizedCodabar', 'msi', 'plessey', 'telepen', 'telepennumeric', 'channelcode', 'posicode', 'bc412'] },
    { id: 'retail', label: 'Comercio y retail (EAN / UPC)', types:
      ['ean13', 'ean8', 'ean2', 'ean5', 'ean14', 'upca', 'upce', 'isbn', 'ismn', 'issn', 'sscc18'] },
    { id: 'gs1', label: 'Logística GS1', types:
      ['gs1-128', 'databaromni', 'databartruncated', 'databarstacked', 'databarstackedomni', 'databarlimited',
       'databarexpanded', 'databarexpandedstacked', 'gs1datamatrix', 'gs1datamatrixrectangular', 'gs1qrcode',
       'gs1dotcode', 'gs1dldatamatrix', 'gs1dlqrcode', 'gs1northamericancoupon'] },
    { id: '2d', label: 'Códigos 2D', types:
      ['qrcode', 'microqrcode', 'rectangularmicroqrcode', 'datamatrix', 'datamatrixrectangular', 'pdf417',
       'pdf417compact', 'micropdf417', 'azteccode', 'azteccodecompact', 'maxicode', 'codablockf', 'hanxin',
       'dotcode', 'code16k', 'code49', 'codeone', 'ultracode'] },
    { id: 'salud', label: 'Sanitario y farmacéutico (HIBC)', types:
      ['hibccode128', 'hibccode39', 'hibcdatamatrix', 'hibcdatamatrixrectangular', 'hibcqrcode', 'hibcpdf417',
       'hibcmicropdf417', 'hibcazteccode', 'hibccodablockf', 'pzn', 'pharmacode', 'pharmacode2', 'code32'] },
    { id: 'postal', label: 'Códigos postales', types:
      ['postnet', 'planet', 'onecode', 'royalmail', 'kix', 'mailmark', 'japanpost', 'auspost', 'identcode', 'leitcode'] },
    { id: 'otros', label: 'Otros y especiales', types:
      ['swissqrcode', 'flattermarken', 'mands', 'aztecrune'] }
  ];

  var ECLEVELS = {
    qr: [
      { value: 'L', label: 'Baja (7 %) — máxima densidad de datos' },
      { value: 'M', label: 'Media (15 %) — recomendada', selected: true },
      { value: 'Q', label: 'Alta (25 %)' },
      { value: 'H', label: 'Máxima (30 %) — útil con logo superpuesto' }
    ],
    aztec: [
      { value: '', label: 'Automática (recomendada)', selected: true },
      { value: '1', label: 'Nivel 1 (~10 %)' },
      { value: '2', label: 'Nivel 2 (~23 %)' },
      { value: '3', label: 'Nivel 3 (~36 %)' },
      { value: '4', label: 'Nivel 4 (~50 %)' }
    ],
    pdf417: [
      { value: '', label: 'Automática (recomendada)', selected: true },
      { value: '0', label: '0 (mínima)' }, { value: '1', label: '1' }, { value: '2', label: '2' },
      { value: '3', label: '3' }, { value: '4', label: '4' }, { value: '5', label: '5' },
      { value: '6', label: '6' }, { value: '7', label: '7' }, { value: '8', label: '8 (máxima)' }
    ]
  };

  // Identificadores de aplicación GS1 más usados en almacén. No es la
  // lista completa del estándar: son los que de verdad rellena un
  // operario de expedición.
  var AI_HELPER = [
    { ai: '01', label: 'GTIN (código de producto)', type: 'text', maxlength: 14, placeholder: '00012345600012' },
    { ai: '10', label: 'Lote', type: 'text', maxlength: 20, placeholder: 'LOTE7' },
    { ai: '21', label: 'Número de serie', type: 'text', maxlength: 20, placeholder: 'SN00123' },
    { ai: '17', label: 'Fecha de caducidad', type: 'date' },
    { ai: '11', label: 'Fecha de producción', type: 'date' },
    { ai: '30', label: 'Cantidad (unidades)', type: 'number', placeholder: '24' }
  ];

  // -----------------------------------------------------------------
  // Estado y referencias al DOM
  // -----------------------------------------------------------------
  var $ = function (id) { return document.getElementById(id); };
  var els = {
    search: $('gc-search'),
    catTabs: $('gc-cat-tabs'),
    typeSelect: $('gc-type'),
    hint: $('gc-hint'),
    data: $('gc-data'),
    useExample: $('gc-use-example'),
    gs1Panel: $('gc-gs1-panel'),
    gs1Fields: $('gc-gs1-fields'),
    gs1Build: $('gc-gs1-build'),
    scale: $('gc-scale'),
    scaleOut: $('gc-scale-out'),
    heightRow: $('gc-height-row'),
    height: $('gc-height'),
    includetext: $('gc-includetext'),
    rotate: $('gc-rotate'),
    barcolor: $('gc-barcolor'),
    backgroundcolor: $('gc-backgroundcolor'),
    margin: $('gc-margin'),
    eclevelRow: $('gc-eclevel-row'),
    eclevelLabel: $('gc-eclevel-label'),
    eclevel: $('gc-eclevel'),
    canvas: $('gc-canvas'),
    preview: $('gc-preview'),
    status: $('gc-status'),
    error: $('gc-error'),
    dims: $('gc-dims'),
    downloadPng: $('gc-download-png'),
    downloadSvg: $('gc-download-svg'),
    generate: $('gc-generate')
  };

  if (!els.typeSelect || !els.canvas) return; // markup no presente

  var currentSvg = null;
  var currentBcid = null;
  var debounceTimer = null;

  // -----------------------------------------------------------------
  // Construcción de los selectores
  // -----------------------------------------------------------------
  function poblarCategorias() {
    CATEGORIES.forEach(function (cat) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'gc-tab';
      btn.textContent = cat.label;
      btn.setAttribute('data-cat', cat.id);
      btn.setAttribute('aria-pressed', cat.id === 'populares' ? 'true' : 'false');
      if (cat.id === 'populares') btn.classList.add('is-active');
      btn.addEventListener('click', function () {
        els.search.value = '';
        activarCategoria(cat.id);
      });
      els.catTabs.appendChild(btn);
    });
  }

  function activarCategoria(catId) {
    var botones = els.catTabs.querySelectorAll('.gc-tab');
    for (var i = 0; i < botones.length; i++) {
      var activo = botones[i].getAttribute('data-cat') === catId;
      botones[i].classList.toggle('is-active', activo);
      botones[i].setAttribute('aria-pressed', activo ? 'true' : 'false');
    }
    var cat = CATEGORIES.filter(function (c) { return c.id === catId; })[0];
    poblarTipos(cat ? cat.types : []);
  }

  function poblarTipos(lista, seleccionar) {
    els.typeSelect.innerHTML = '';
    lista.forEach(function (bcid) {
      var t = TYPES[bcid];
      if (!t) return;
      var opt = document.createElement('option');
      opt.value = bcid;
      opt.textContent = t.label;
      els.typeSelect.appendChild(opt);
    });
    if (seleccionar && lista.indexOf(seleccionar) !== -1) {
      els.typeSelect.value = seleccionar;
    }
    onTipoCambiado();
  }

  function normalizar(s) {
    return (s || '').toString().toLowerCase()
      .normalize('NFD').replace(/[̀-ͯ]/g, '');
  }

  function buscar(consulta) {
    var q = normalizar(consulta);
    if (!q) { activarCategoria('populares'); return; }
    var botones = els.catTabs.querySelectorAll('.gc-tab');
    for (var i = 0; i < botones.length; i++) {
      botones[i].classList.remove('is-active');
      botones[i].setAttribute('aria-pressed', 'false');
    }
    var coincidencias = Object.keys(TYPES).filter(function (bcid) {
      return normalizar(TYPES[bcid].label).indexOf(q) !== -1 || normalizar(bcid).indexOf(q) !== -1;
    }).sort(function (a, b) { return TYPES[a].label.localeCompare(TYPES[b].label); });
    poblarTipos(coincidencias);
  }

  // -----------------------------------------------------------------
  // Panel de opciones según el tipo elegido
  // -----------------------------------------------------------------
  function onTipoCambiado() {
    var bcid = els.typeSelect.value;
    var t = TYPES[bcid];
    if (!t) return;

    els.hint.textContent = t.hint || '';
    els.hint.hidden = !t.hint;
    els.data.placeholder = 'Ej.: ' + t.example;
    els.useExample.setAttribute('data-example', t.example);

    els.heightRow.hidden = !t.linear;
    els.includetext.checked = !!t.text;

    if (t.family && ECLEVELS[t.family]) {
      els.eclevelRow.hidden = false;
      els.eclevelLabel.textContent = t.family === 'pdf417' ? 'Nivel de corrección (0-8)' : 'Corrección de errores';
      els.eclevel.innerHTML = '';
      ECLEVELS[t.family].forEach(function (o) {
        var opt = document.createElement('option');
        opt.value = o.value;
        opt.textContent = o.label;
        if (o.selected) opt.selected = true;
        els.eclevel.appendChild(opt);
      });
    } else {
      els.eclevelRow.hidden = true;
    }

    els.gs1Panel.hidden = !t.gs1;
    if (t.gs1 && !els.gs1Fields.childElementCount) construirAsistenteGS1();

    if (!els.data.value.trim() || els.data.getAttribute('data-auto') === '1') {
      els.data.value = t.example;
      els.data.setAttribute('data-auto', '1');
    }

    programarGeneracion();
  }

  function construirAsistenteGS1() {
    AI_HELPER.forEach(function (campo) {
      var wrap = document.createElement('div');
      wrap.className = 'field gc-gs1-field';
      var input = document.createElement('input');
      input.type = campo.type;
      input.id = 'gc-ai-' + campo.ai;
      input.className = 'field__input';
      if (campo.placeholder) input.placeholder = campo.placeholder;
      if (campo.maxlength) input.maxLength = campo.maxlength;
      var label = document.createElement('label');
      label.className = 'field__label';
      label.setAttribute('for', input.id);
      label.textContent = '(' + campo.ai + ') ' + campo.label;
      wrap.appendChild(input);
      wrap.appendChild(label);
      els.gs1Fields.appendChild(wrap);
    });
  }

  function fechaAAMMDD(valorInput) {
    // <input type="date"> entrega AAAA-MM-DD; GS1 quiere AAMMDD.
    var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(valorInput || '');
    return m ? m[1].slice(2) + m[2] + m[3] : '';
  }

  function construirCadenaGS1() {
    var partes = [];
    AI_HELPER.forEach(function (campo) {
      var input = $('gc-ai-' + campo.ai);
      if (!input || !input.value) return;
      var valor = campo.type === 'date' ? fechaAAMMDD(input.value) : input.value.trim();
      if (!valor) return;
      partes.push('(' + campo.ai + ')' + valor);
    });
    if (!partes.length) return;
    els.data.value = partes.join('');
    els.data.removeAttribute('data-auto');
    generar();
  }

  // -----------------------------------------------------------------
  // Generación con bwip-js
  // -----------------------------------------------------------------
  function opciones() {
    var bcid = els.typeSelect.value;
    var t = TYPES[bcid];
    var opts = {
      bcid: bcid,
      text: els.data.value,
      scale: parseInt(els.scale.value, 10) || 3,
      includetext: els.includetext.checked,
      textxalign: 'center',
      rotate: els.rotate.value,
      backgroundcolor: (els.backgroundcolor.value || '#ffffff').replace('#', ''),
      barcolor: (els.barcolor.value || '#000000').replace('#', ''),
      paddingwidth: parseFloat(els.margin.value) || 0,
      paddingheight: parseFloat(els.margin.value) || 0
    };
    if (t && t.linear) {
      opts.height = parseFloat(els.height.value) || 15;
    }
    if (t && t.family && !els.eclevelRow.hidden && els.eclevel.value !== '') {
      opts.eclevel = els.eclevel.value;
    }
    if (t && t.gs1) {
      opts.parse = true;
    }
    return opts;
  }

  function programarGeneracion() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(generar, 250);
  }

  function mostrarError(mensaje) {
    els.error.hidden = false;
    els.error.textContent = mensaje;
    els.status.textContent = '';
    els.downloadPng.disabled = true;
    els.downloadSvg.disabled = true;
  }

  function generar() {
    els.error.hidden = true;
    if (!els.data.value.trim()) {
      mostrarError('Escribe el contenido que quieres codificar.');
      return;
    }
    var opts = opciones();
    try {
      bwipjs.toCanvas(els.canvas, opts);
      currentSvg = bwipjs.toSVG(opts);
      currentBcid = opts.bcid;
      els.dims.textContent = els.canvas.width + ' × ' + els.canvas.height + ' px';
      els.canvas.setAttribute('aria-label',
        (TYPES[opts.bcid] ? TYPES[opts.bcid].label : opts.bcid) + ' generado con el valor: ' + opts.text);
      els.status.textContent = '';
      els.downloadPng.disabled = false;
      els.downloadSvg.disabled = false;
    } catch (e) {
      mostrarError(traducirError(String(e)));
    }
  }

  function traducirError(msg) {
    var m = msg.replace(/^Error:\s*/i, '');
    if (/too short|too long|invalid length/i.test(m)) return 'La longitud del dato no es válida para este tipo de código: ' + m;
    if (/bad character|invalid character|not in character set/i.test(m)) return 'Hay un carácter que este tipo de código no admite: ' + m;
    if (/checksum|check digit/i.test(m)) return 'El dígito de control no cuadra: revisa el valor introducido. (' + m + ')';
    return 'No se ha podido generar el código: ' + m;
  }

  // -----------------------------------------------------------------
  // Descargas
  // -----------------------------------------------------------------
  function nombreFichero(ext) {
    return 'codigo-' + (currentBcid || 'barcode') + '-' + Date.now() + '.' + ext;
  }

  function descargarBlob(blob, nombre) {
    var url = URL.createObjectURL(blob);
    var a = document.createElement('a');
    a.href = url;
    a.download = nombre;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    setTimeout(function () { URL.revokeObjectURL(url); }, 1000);
  }

  els.downloadPng.addEventListener('click', function () {
    els.canvas.toBlob(function (blob) {
      if (blob) descargarBlob(blob, nombreFichero('png'));
    }, 'image/png');
  });

  els.downloadSvg.addEventListener('click', function () {
    if (!currentSvg) return;
    descargarBlob(new Blob([currentSvg], { type: 'image/svg+xml' }), nombreFichero('svg'));
  });

  // -----------------------------------------------------------------
  // Cableado de eventos
  // -----------------------------------------------------------------
  els.typeSelect.addEventListener('change', onTipoCambiado);
  els.search.addEventListener('input', function () { buscar(els.search.value); });
  els.useExample.addEventListener('click', function () {
    els.data.value = els.useExample.getAttribute('data-example') || '';
    els.data.removeAttribute('data-auto');
    generar();
  });
  els.gs1Build.addEventListener('click', construirCadenaGS1);
  els.generate.addEventListener('click', generar);
  [els.data, els.scale, els.height, els.includetext, els.rotate,
    els.barcolor, els.backgroundcolor, els.margin, els.eclevel].forEach(function (el) {
    if (!el) return;
    var evento = (el.type === 'checkbox' || el.tagName === 'SELECT') ? 'change' : 'input';
    el.addEventListener(evento, function () {
      if (el === els.data) els.data.removeAttribute('data-auto');
      programarGeneracion();
    });
  });
  els.scale.addEventListener('input', function () { els.scaleOut.textContent = 'x' + els.scale.value; });

  // -----------------------------------------------------------------
  // Arranque
  // -----------------------------------------------------------------
  poblarCategorias();
  activarCategoria('populares');
  poblarTipos(CATEGORIES[0].types, 'code128');
  els.scaleOut.textContent = 'x' + els.scale.value;
  generar();
})();
